import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

export function PreparationForTomorrowCard(): React.ReactElement {
  const loading = false
  const hasPayload = true
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasPayload)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Preparation for tomorrow"
      showTitleChevron={false}
      className="dashboard-huddle-followups-card dashboard-huddle-full-row"
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-alerts-list">
        <details>
          <summary>
            <span className="alerts-row-label">Recalls due</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">4</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>3 patients due for 6-month recall.</div>
            <div>1 patient due for perio maintenance.</div>
          </div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Pre-auths expiring</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">1</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>Sarah Wilson — auth expires in 5 days.</div>
          </div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Lab cases due</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">2</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>Crown delivery — Dr. Smith.</div>
            <div>Night guard — Dr. Johnson.</div>
          </div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Planned callbacks</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">3</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>Confirm appointments for tomorrow.</div>
          </div>
        </details>
      </div>
    </DashboardSectionCard>
  )
}
